export default __webpack_public_path__ + "static/media/medicos_disponibles.642b7db1.svg";